<mat-sidenav-container class="sidenav-container">
    <mat-sidenav
        #drawer
        class="sidenav"
        fixedInViewport
        [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
        [mode]="(isHandset$ | async) ? 'over' : 'side'"
        [opened]="(isHandset$ | async) === false">
        <div class="sidenav-container__content">
            <mat-toolbar>
                <div id="logo" (click)="onLogoClick()">
                    <app-logo></app-logo>
                </div>
            </mat-toolbar>
            <mat-nav-list class="navigation-links">
                <a
                    class="navigation-link"
                    mat-list-item
                    routerLink="/home"
                    routerLinkActive="navigation-link__active"
                    [matTooltip]="'navigationMenu.home' | translate"
                    [matTooltipPosition]="'right'">
                    <mat-icon class="navigation-link__icon icon-grey-color" svgIcon="home"></mat-icon>
                </a>
                <a
                    class="navigation-link"
                    routerLink="/area-marketing/gestiones-comerciales"
                    mat-list-item
                    [class.navigation-link__active]="setNavItemActive('area-marketing')"
                    routerLinkActive="navigation-link__active"
                    [matTooltip]="'common.marketing-area' | translate"
                    [matTooltipPosition]="'right'">
                    <mat-icon class="navigation-link__icon icon-grey-color" svgIcon="suitcase"></mat-icon>
                </a>
                <a
                    class="navigation-link"
                    routerLink="/clientes"
                    mat-list-item
                    routerLinkActive="navigation-link__active"
                    [matTooltip]="'navigationMenu.customers' | translate"
                    [matTooltipPosition]="'right'">
                    <mat-icon class="navigation-link__icon icon-grey-color" svgIcon="folder_client"></mat-icon>
                </a>
                <a
                    class="navigation-link"
                    routerLink="/sucursales"
                    mat-list-item
                    routerLinkActive="navigation-link__active"
                    [matTooltip]="'navigationMenu.offices' | translate"
                    [matTooltipPosition]="'right'">
                    <mat-icon class="navigation-link__icon icon-grey-color" svgIcon="offices"></mat-icon>
                </a>
                <a
                    class="navigation-link"
                    [class.navigation-link__notices]="noticesCount > 0"
                    routerLink="/consultas"
                    mat-list-item
                    routerLinkActive="navigation-link__active"
                    [matTooltip]="'common.consultations' | translate"
                    [matTooltipPosition]="'right'">
                    <span *ngIf="noticesCount" class="count-label">{{ noticesCount }}</span>
                    <mat-icon class="navigation-link__icon icon-grey-color" svgIcon="search"></mat-icon>
                </a>
                <a
                    class="navigation-link"
                    routerLink="/informes/clientes"
                    mat-list-item
                    [class.navigation-link__active]="setNavItemActive('informes')"
                    [matTooltip]="'common.reports' | translate"
                    [matTooltipPosition]="'right'">
                    <mat-icon class="navigation-link__icon icon-grey-color" svgIcon="report"></mat-icon>
                </a>
                <a
                    class="navigation-link"
                    routerLink="/documentacion-general"
                    mat-list-item
                    routerLinkActive="navigation-link__active"
                    [matTooltip]="'common.general-documentation' | translate"
                    [matTooltipPosition]="'right'">
                    <mat-icon class="navigation-link__icon icon-grey-color" svgIcon="contract"></mat-icon>
                </a>
                <a
                    class="navigation-link"
                    routerLink="/procedimientos"
                    mat-list-item
                    routerLinkActive="navigation-link__active"
                    [matTooltip]="'common.procedures' | translate"
                    [matTooltipPosition]="'right'">
                    <mat-icon class="navigation-link__icon icon-grey-color" svgIcon="reiterations"></mat-icon>
                </a>
            </mat-nav-list>
            <mat-nav-list class="navigation-settings">
                <a
                    class="navigation-link"
                    mat-list-item
                    [matTooltip]="'navigationMenu.logout' | translate"
                    [matTooltipPosition]="'right'"
                    (click)="onLogout()">
                    <mat-icon svgIcon="logout"></mat-icon>
                </a>
            </mat-nav-list>
        </div>
    </mat-sidenav>
    <mat-sidenav-content>
        <ng-content></ng-content>
    </mat-sidenav-content>
</mat-sidenav-container>
